var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.105 3.715c.181-.437.566-.715.989-.715h11.814c.424 0 .806.278.987.715.183.436.126.953-.164 1.327l-4.98 6.986V16c0 .378-.186.725-.484.894a.785.785 0 01-.916-.094L8.6 15.3a1.047 1.047 0 01-.35-.8v-2.472L3.247 5.042a1.396 1.396 0 01-.142-1.327z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default ForwardRef;